import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap'
import { API, username } from '../API';
import Api from '../Api/Api';
import { isAutheticated } from "./auth/authhelper";
import { useAppContext } from '../Context/AppContext';


function ToastProduct({ product, handleClose, pauseVid, handleShowPopUp }) {
  const { addToCart } = useAppContext();
  const { token } = isAutheticated()
  const [currentProduct, setCurrentProduct] = useState(false)
  // const [currentTimeout, setCurrentTimeout] = useState(false)

  // useEffect(() => {
  //   let timeout = setTimeout(function () { handleClose(); }, parseInt(`${product.duration}000`))
  //   return (() => {
  //     clearTimeout(timeout)
  //   })
  // })
  useEffect(() => {
    let popupTimeout; // To manage the timeout
    let alternateInterval; // To manage the alternating interval
    let isPopupVisible = false; // Track popup visibility

    const showPopup = () => {
      handleShowPopUp(); // Show the popup
      isPopupVisible = true;
    };

    const hidePopup = () => {
      handleClose(); // Hide the popup
      isPopupVisible = false;
    };

    const togglePopup = () => {
      if (isPopupVisible) {
        hidePopup(); // Hide if currently visible
      } else {
        showPopup(); // Show if currently hidden
      }
    };

    if (product?.duration === "throughout") {
      // Clear any existing interval to prevent multiple timers
      clearInterval(alternateInterval);

      // Show popup after 5 seconds initially
      popupTimeout = setTimeout(() => {
        showPopup(); // Initial show after 5 seconds

        // Alternate between show (30 seconds) and hide (5 seconds)
        alternateInterval = setInterval(() => {
          togglePopup();
        }, isPopupVisible ? 30000 : 5000); // Show for 30s, hide for 5s
      }, 5000);
    } else if (product?.duration) {
      // Show popup for the specified duration (in seconds)
      const durationInMs = parseInt(`${product.duration}000`, 10); // Convert to milliseconds
      showPopup(); // Show the popup
      popupTimeout = setTimeout(() => {
        hidePopup(); // Close the popup after the specified duration
      }, durationInMs);
    }

    // Cleanup on component unmount or dependency changes
    return () => {
      clearTimeout(popupTimeout); // Clear any timeout
      clearInterval(alternateInterval); // Clear any interval
    };
  }, [product?.duration, handleClose, handleShowPopUp]);










  // console.log("product", product)

  // const enterMouse =  () => {
  //   console.log("enter");
  //   clearTimeout(timeout)
  // }
  // const leaveMouse = () => {
  //   console.log("leave");
  //   timeout = setTimeout(function () { handleClose(); }, parseInt(`${product.duration}000`))
  // }


  // const buttonClick = async () => {
  //   // window.open(product?.url);
  //   pauseVid()
  //   // addToCart()
  //   addToCart(product)
  //   const { data } = await Api.postOrder(username, product.product?._id, product.CTA);
  //   console.log(data);
  // }
  const buttonClick = async () => {
    try {
      pauseVid(); // Ensure this function is defined

      addToCart(product); // Add product to cart

      // Ensure `username` is available
      if (!username || !product?.product?._id || !product.CTA) {
        console.error("Missing required data for order.");
        return;
      }

      // Place order
      const { data } = await Api.postOrder(username, product.product?._id, product.CTA);
      console.log("Order response:", data);

    } catch (error) {
      console.error("Error in buttonClick:", error);
    }
  };


  console.log(product)


  return (
    <Toast style={{
      width: "100%",
      maxWidth: "800px",
      maxHeight: "250px",
      overflow: "hidden",
    }}>
      <Toast.Header
        className="justify-content-between align-items-center p-2"
        closeButton={false}
      >
        <div className="d-flex rounded w-100">
          {/* Left Column: Product Thumbnail (1/3 width) */}
          <div
            className="d-flex align-items-center justify-content-center p-1"
            style={{ flex: "1" }}
          >
            <img
              className="img-fluid rounded shadow"
              src={
                product?.type === "external"
                  ? product?.ProductThumbnail_Url
                  : product?.product?.image || product?.url
              }
              alt="Product Thumbnail"
              style={{
                maxHeight: "150px",
                width: "100%",
                objectFit: "cover",
                cursor: product?.type === "external" ? "pointer" : "default",
              }}
              onClick={() => {
                if (product?.type === "external" && product?.externalProductUrl) {
                  pauseVid()
                  window.open(product?.externalProductUrl, "_blank");
                }
              }}
            />
          </div>

          {/* Right Column: Product Details and Buttons (2/3 width) */}
          <div
            className="d-flex flex-column justify-content-between p-2"
            style={{ flex: "2" }}
          >
            {/* Product Details */}
            <div>
              <h5 className="fw-bold mb-1">
                {product?.type === "external"
                  ? product?.extProduct_Name
                  : product?.product?.title}
              </h5>
              <p
                className="fw-semibold text-dark mb-1"
                style={{
                  fontSize: "1rem",
                  color: "#333",
                  fontWeight: "bold",
                  letterSpacing: "0.5px",
                }}
              >
                {product?.type === "external"
                  ? `${product?.extProduct_Price}`
                  : `${product?.product?.sale_price}`}
              </p>
              <p
                className="text-muted mb-1"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {product?.type === "external"
                  ? product?.extProduct_Description
                  : product?.product?.description}
              </p>
            </div>

            {/* Buttons */}
            <div>
              {product?.type === "external" && product?.externalProductUrl && (
                <button
                  onClick={() => {
                    pauseVid()
                    window.open(product.externalProductUrl, "_blank")
                  }}
                  className="btn btn-warning w-100 mb-1"
                  style={{ fontSize: "0.9rem", padding: "6px" }}
                >
                  <i className="bi bi-box-arrow-up-right me-1"></i>
                  {product?.show_Button_Name || "Visit Product"}
                </button>
              )}
              {product?.type === "internal" && (
                <button
                  onClick={buttonClick}
                  className="btn btn-warning w-100 mb-1"
                  style={{ fontSize: "0.9rem", padding: "6px" }}
                >
                  <i className="bi bi-box-arrow-up-right me-1"></i>
                  {product?.show_Button_Name || "Visit Product"}
                </button>
              )}
            </div>
          </div>
        </div>
      </Toast.Header>
    </Toast>




  )
}

export default ToastProduct